import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserNotes} from 'src/openapi/admin/apis/GetUserNotesApi';
import {saveUserNotes} from 'src/openapi/admin/apis/SaveUserNotesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {UserNote} from 'src/openapi/admin/models/UserNote';

type Props = {
    userId: number,
};

export const useUserNotes = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserNotes({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((userNotes: UserNote) => apiDispatch(
        saveUserNotes({userId, body: userNotes.value}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {value: ''},
    });
};
